import { Routes } from '@angular/router';
import { PermissionsEnum } from '../permission.enum';
import { permissionGuard } from '../shared/core/guard/permission.guard';

export const billingsSettlementRoutes: Routes = [
  {
    path: 'billings',
    canActivate: [permissionGuard(PermissionsEnum.BillingView)],
    loadComponent: () => import('./components/billing/billing.component').then((m) => m.BillingComponent),
  },
  {
    path: 'settlement',
    canActivate: [permissionGuard(PermissionsEnum.BillingView)],
    loadComponent: () => import('./components/settlement/settlement.component').then((m) => m.SettlementComponent),
  },
  {
    path: 'transactions/:orgKey',
    canActivate: [permissionGuard(PermissionsEnum.BillingView)],
    loadComponent: () =>
      import('./components/billing-transactions/billing-transactions.component').then(
        (m) => m.BillingTransactionsComponent
      ),
  },
  {
    path: '',
    redirectTo: 'billings',
    pathMatch: 'full',
  },
];
